var _a;
export var IdTrackingConnection = {
    Header: (_a = {}, _a["Content-Type"] = "text/plain;charset=UTF-8", _a),
    Url: process.env.REACT_APP_TRACKING_URL,
};



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdTrackingConnection.ts
// module id = 1687
// module chunks = 3